(function () {
  const drawer = document.getElementById('mm-drawer');
  const overlay = document.getElementById('mm-overlay');
  const searchPanel = document.getElementById('mm-search-panel');
  const emailForm = document.querySelector('.mm-email-form');
  const formNote = document.querySelector('[data-form-note]');

  function closePanels() {
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (searchPanel) {
      searchPanel.classList.remove('open');
      searchPanel.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('open');
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
  }

  function openSearch() {
    if (!searchPanel || !overlay) return;
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
    const input = searchPanel.querySelector('input');
    window.setTimeout(function () {
      if (input) input.focus();
    }, 120);
  }

  document.querySelectorAll('[data-open-drawer]').forEach(function (button) {
    button.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-open-search]').forEach(function (button) {
    button.addEventListener('click', openSearch);
  });
  document.querySelectorAll('[data-close-panels]').forEach(function (button) {
    button.addEventListener('click', closePanels);
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.mm-nav a, .mm-drawer nav a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = link.getAttribute('href');
    if (!href || href === '#') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = link.href;
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanels();
  });

  if (emailForm && formNote) {
    emailForm.addEventListener('submit', function () {
      formNote.textContent = 'Thank you. Your private edit is reserved.';
      formNote.style.color = 'var(--mm-success)';
    });
  }
})();
